import api from '@/api/axiosApi'
import type { PaginatedCalendarLookupResponse } from './clt.types'

export interface ListCalendarLookupParams {
  year?: number
  dc?: string
  event?: string
  skip?: number
  limit?: number
}

export async function listCalendarLookup(
  params: ListCalendarLookupParams = {}
): Promise<PaginatedCalendarLookupResponse> {
  const { year, dc, event, skip = 0, limit = 300 } = params
  const response = await api.get<PaginatedCalendarLookupResponse>(
    '/calendar-lookup',
    {
      params: {
        year: year ?? undefined,
        dc: dc || undefined,
        event: event || undefined,
        skip,
        limit,
      },
    }
  )
  return response.data
}
